import React from 'react';

function ProductSmokingHero() {
  return (
    <section style={{
      padding: '100px 24px',
      background: 'linear-gradient(180deg, #0a0a0f 0%, #0d1a0e 50%, #0a0a0f 100%)',
      textAlign: 'center',
      position: 'relative',
    }}>
      {/* Glow effect */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'min(400px, 100vw)',
        height: 'min(400px, 100vw)',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(22,183,36,0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 600, margin: '0 auto' }}>
        <h2 style={{
          fontSize: 'clamp(22px, 3.5vw, 36px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 16,
          lineHeight: 1.3,
        }}>
          Зв'яжіться з нами у{' '}
          <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>месенджері</span>
        </h2>
        <p style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: 16,
          marginBottom: 32,
        }}>
          Ми тут, щоб допомогти
        </p>
        <a href="viber://chat?number=%2B380966341617" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
          padding: '16px 40px',
          background: 'transparent',
          color: '#4dc247',
          fontSize: 16,
          fontWeight: 600,
          textDecoration: 'none',
          borderRadius: 50,
          border: '2px solid rgba(22,183,36,0.4)',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          transition: 'all 0.3s ease',
        }}
        onMouseOver={e => {
          e.currentTarget.style.background = 'rgba(22,183,36,0.1)';
          e.currentTarget.style.borderColor = '#16b724';
          e.currentTarget.style.boxShadow = '0 0 30px rgba(22,183,36,0.3)';
        }}
        onMouseOut={e => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.borderColor = 'rgba(22,183,36,0.4)';
          e.currentTarget.style.boxShadow = 'none';
        }}
        >
          Написати у Viber
        </a>
      </div>
    </section>
  );
}

export default ProductSmokingHero;
